export const GET_SERVERGROUPS_REQUEST = "GET_SERVERGROUPS_REQUEST";
export const GET_SERVERGROUPS_SUCCESS = "GET_SERVERGROUPS_SUCCESS";
export const GET_SERVERGROUPS_FAILURE = "GET_SERVERGROUPS_FAILURE";
export const UPDATE_SERVER_GROUPS_SEARCH_KEY =
  "UPDATE_SERVER_GROUPS_SEARCH_KEY";
export const RESET_SERVER_GROUP_LIST = "RESET_SERVER_GROUP_LIST";
